var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#F2F8F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#80B870"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11522_29821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11522_29821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9584 18.625L21.0209 11.5625C21.1875 11.3958 21.382 11.3125 21.6042 11.3125C21.8264 11.3125 22.0209 11.3958 22.1875 11.5625C22.3542 11.7292 22.4375 11.9271 22.4375 12.1562C22.4375 12.3854 22.3542 12.5833 22.1875 12.75L14.5417 20.4167C14.375 20.5833 14.1806 20.6667 13.9584 20.6667C13.7361 20.6667 13.5417 20.5833 13.375 20.4167L9.7917 16.8333C9.62503 16.6667 9.54517 16.4688 9.55211 16.2396C9.55906 16.0104 9.64586 15.8125 9.81253 15.6458C9.9792 15.4792 10.1771 15.3958 10.4063 15.3958C10.6354 15.3958 10.8334 15.4792 11 15.6458L13.9584 18.625Z",
    fill: "#74A766"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circle-right.22cb6f7d9ee5be8a2e3b4190f5e99f68.svg";
export { ForwardRef as ReactComponent };